import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { SikdaeGivenForm, SikdaeGivenResult } from 'components/SikdaeGivenList';
import { LoadingBar } from 'components/Commons';
import download from 'downloadjs';

import * as cm_action from 'actions/commons';
import * as sik_action from 'actions/sikdae';

import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import api from 'config';

import ExcelRequestCompleteModal from './ExcelRequestCompleteModal';

class SikdaeGivenList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      pagerow: 15,
      dateSearchType: 'REG',

      modalIdx: 0,
      modal: false,
      modalPage: 1,
      modalPagerow: 10,

      isLoading: false,
      isVisbles: false
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);

    this.sikdaeStatus();
    this.sikdaeGroup();
    this.sikdaeListSel();
  }

  componentDidMount() {
    cm.mainTitle('식대 내역');
  }

  //상태 정보
  sikdaeStatus = () => {
    const { sikAPI } = this.props;
    try {
      sikAPI.sikdaeStatus();
    } catch (e) {
      console.log('##### sikdaeStatus : ', e);
    }
  };

  //식대 그룹 조회
  sikdaeGroup = () => {
    const { cmAPI } = this.props;

    try {
      cmAPI.sikdaeGroupList();
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
    } finally {
    }
  };

  //식대그룹 search
  sikdaeGroupSearch = async () => {
    const { groupIdx } = this.props;

    if (groupIdx.value !== 0) {
      const { cmAPI } = this.props;

      try {
        //식대정책 조회
        await cmAPI.sikdaePolicyList(groupIdx.value);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }
    }
  };

  //확인
  submitForm = async (e) => {
    e.preventDefault();

    const { pagerow } = this.state;
    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }

    await this.setState({
      page: 1,
      pagerow: pagerow
    });

    this.sikdaeListSel();
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  //날짜 검색 타입 변경
  handleDateSearchTypeChange = async (e, { value }) => {
    await this.setState({ dateSearchType: value });
  };

  //검색 값들을 모아 전송 후 리스트 받기
  sikdaeListSel = () => {
    const { page, pagerow, dateSearchType } = this.state;
    const { date, statusStr, groupIdx, policyIdx, text } = this.props;

    const params = {
      startdate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LLL'),
      enddate: date ? date.eDate : moment().format('LLL'),
      code: statusStr ? statusStr.value : null,
      groupid: groupIdx ? groupIdx.value : null,
      policyid: policyIdx ? policyIdx.value : null,
      keyword: text ? text.value : null,
      page: page,
      pagerow: pagerow,
      dateSearchType: dateSearchType
    };

    const { sikAPI } = this.props;
    sikAPI.givenList(params);

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: params
    });
  };

  //페이지 이동
  pageClick = async (pageNum) => {
    await this.setState({ page: pageNum });
    this.sikdaeListSel();
  };

  //상세 모달 열기
  openModal = async (id) => {
    await this.setState({
      modal: true,
      modalIdx: id,
      modalPage: 1
    });

    await this.givenDetailSel();
  };

  //상세 모달 닫기
  closeModal = () => this.setState({ modal: false });

  //상세 내역
  givenDetailSel = () => {
    const { sikAPI } = this.props,
      { modalIdx, modalPage, modalPagerow } = this.state,
      params = {
        page: modalPage,
        pagerow: modalPagerow
      };

    sikAPI.givenDetail(modalIdx, params);
  };

  //상세내역 페이지 이동
  detailPageClick = async (pageNum) => {
    await this.setState({ modalPage: pageNum });
    this.givenDetailSel();
  };

  //모달(식대내역 상세) 엑셀 다운로드
  downloadExcel = async () => {
    const { modalIdx } = this.state,
      com = storage.get('company'),
      { excelResult, cmAPI } = this.props;
    const { userCount } = storage.get('userCount');

    let header = null;
    const url = this.props.history.location.pathname;
    const isAsyncExcelDown =
      url === '/main/userSikdaeGivenList' ||
      url === '/main/sikdaeGivenList' ||
      url === '/main/DetailedSikdae' ||
      url === '/main/DetailedSikdaePro' ||
      url === '/main/DetailedSikdaeSamsungSds';

    try {
      await this.setState({
        downloadExcelFile: '',
        isLoading: true
      });

      if (isAsyncExcelDown && userCount && userCount >= 1000) {
        setTimeout(() => {
          this.setState({ isLoading: false, isVisbles: true });
        }, 5000);
      }

      const params = {
        com: com,
        excel: {
          url: '/coupon/v1/task/' + modalIdx + '/download',
          method: 'get'
        },
        excelResult: {
          excel: {
            requestid: com.user.id
          }
        }
      };

      await cmAPI.excelDownload(params);

      if (isAsyncExcelDown && userCount < 1000) {
        const { excelDownloadReault } = this.props;

        if (excelDownloadReault) {
          header = excelDownloadReault.headers['content-disposition'];
          header = header.split('=');

          download(excelDownloadReault.data, decodeURIComponent(header[1]));
          toastr('top-right', 'success', ' 엑셀파일 생성 완료 되었습니다.');
        }
      }
    } catch (e) {
      const result = e.response;

      if (result && result.data) {
        let status = result.status;

        toastr('top-right', 'error', ' 엑셀파일 생성에 실패 하였습니다.(' + String(status) + ')');
      }
      console.log('###### ExcelDownLoad : ', e);
    } finally {
      if (!isAsyncExcelDown || userCount < 1000) {
        await this.setState({ isLoading: false });
      }
    }

    // location.href = api.config.companyAPI + "/coupon/v1/task/" + modalIdx + "/download"
    //                 + "?filetype=excel&comid=" + com.id + "&requestid=" + com.user.id;
  };

  //지급예약 취소
  cancelSikdae = async () => {
    const { modalIdx } = this.state,
      { sikAPI } = this.props;

    try {
      await sikAPI.cancelReservation(modalIdx);
      const { cancelSikdae } = this.props;

      if (cancelSikdae) {
        if (cancelSikdae.status === 204) {
          await this.closeModal();
          this.sikdaeListSel();
        } else {
          alert('예약 취소 오류입니다.');
        }
      } else {
        toastr('top-right', 'warning', '예약 취소 오류입니다.');
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### cancelSikdae error : ', e);
    } finally {
    }
  };

  onExcelDownList = () => {
    const { history } = this.props;
    this.setState({ isVisbles: false });
    history.push('/main/excelDownloadList');
  };

  render() {
    const { page, pagerow, modal, modalPage, modalPagerow, isVisbles, isLoading, dateSearchType } = this.state,
      { sikdaeList, groupIdx } = this.props,
      formFn = {
        sikdaeGroupSearch: this.sikdaeGroupSearch,
        sikdaePolicySearch: this.sikdaePolicySearch,
        sikdaeGroupVal: groupIdx,
        submitForm: this.submitForm,
        handleEntSubmit: this.handleEntSubmit,
        dateSearchType: dateSearchType,
        handleDateSearchTypeChange: this.handleDateSearchTypeChange
      },
      resultFn = {
        page: page,
        pagerow: pagerow,
        pageClick: this.pageClick
      },
      modalFn = {
        modal: modal,
        modalPage: modalPage,
        modalPagerow: modalPagerow,

        openModal: this.openModal,
        closeModal: this.closeModal,
        detailPageClick: this.detailPageClick,

        cancelSikdae: this.cancelSikdae,
        downloadExcel: this.downloadExcel,
        isLoading: isLoading
      };

    let loading = '';

    if (!sikdaeList) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        {loading}

        <SikdaeGivenForm formFn={formFn} />

        <SikdaeGivenResult resultFn={resultFn} modalFn={modalFn} />

        <ExcelRequestCompleteModal
          open={isVisbles}
          close={() => this.setState({ isVisbles: false })}
          onExcelDownList={this.onExcelDownList}
        />
      </main>
    );
  }
}

SikdaeGivenList = connect(
  (state) => ({
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    pageRow: state.commons.pagerow,
    statusStr: state.commons.statusStr,
    groupIdx: state.commons.group,
    policyIdx: state.commons.policy,
    text: state.commons.text,

    excelResult: state.commons.excel,

    sikdaeList: state.sikdae.sikdaeGivenList,
    cancelSikdae: state.sikdae.cancelSikdae,
    excelDownloadReault: state.commons.excelDownload
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList,
        sikdaePolicyList: cm_action.SikdaePolicyList,
        //excel download
        changeExcel: cm_action.ChangeExcel,
        excelDownload: cm_action.ExcelDownload
      },
      dispatch
    ),
    sikAPI: bindActionCreators(
      {
        sikdaeStatus: sik_action.SikdaeStatusList,
        givenList: sik_action.SikdaeGivenList,
        givenDetail: sik_action.SikdaeGivenDetail,
        cancelReservation: sik_action.CancelReservation
      },
      dispatch
    )
  })
)(SikdaeGivenList);

export default SikdaeGivenList;
